// extracted by mini-css-extract-plugin
export default {"contentEditorFormattingBlockColumn":"sqBhYC_rCcX8WHvyt1jA"};